export enum AttestationDateMode {
  ExactDate = 0,
  AttestationDate = 1,
  AttestationDateAfter = 2,
}
